import moment from 'moment';

export const getDate = (dateString, format = 'YYYY-MM-DD') => {
  return dateString ? moment(dateString, format).toDate() : moment().toDate();
};
